const workScheme = [
    "Remoto",
    "Presencial",
    "Híbrido",
  ];
  
  export default workScheme;
  